import React, { Component } from 'react';
import { HashRouter as Router, Switch, Route, Link } from 'react-router-dom';
import Home from "./components/home";
import About from "./components/about";
import Contact from "./components/contact";
import logo from './images/Vanstone Bailey.svg';
import './App.css';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Social from './components/social'

class App extends Component {
  render() {
    return (
     <div className="App">
      <Navbar className="p-1" bg="primary" variant='dark' expand="sm">
          <Navbar.Brand href="#home" className="p-0">
            <img src={logo} className="Nav-logo" alt="logo" />
          </Navbar.Brand>
          <Nav className="mr-auto" >
            <Nav.Link href="#home" className='p-2'>Home</Nav.Link>
            <Nav.Link href="#about" className='p-2'>About</Nav.Link>
            <Nav.Link href="#contact" className='p-2'>Contact</Nav.Link>
          </Nav>
      </Navbar>  
      <footer className="fixed-bottom">
            <Social />
      </footer>
        
    </div>
    );
  }
}

export default App;
